import React, { useContext } from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import AnimationContainer from '../../components/animation-container';

import {
  faSmileBeam,
  faTasks,
  faQuoteRight,
  faCode,
} from '@fortawesome/free-solid-svg-icons';
import Counter from '../../components/counter';
import ThemeContext from '../../context';

const About = ({ id }) => {
  const { height } = useContext(ThemeContext);

  const facts = [
    {
      icon: faSmileBeam,
      value: 25,
      text: 'Happy Clients',
      symbol: '+',
      duration: 6,
    },
    {
      icon: faTasks,
      value: 60,
      text: 'Projects Delivered',
      symbol: '+',
      duration: 5,
    },
    {
      icon: faQuoteRight,
      value: 15,
      text: 'Reviews',
      symbol: '+',
      duration: 6,
    },
    {
      icon: faCode,
      value: 5000,
      text: 'Lines of Code',
      symbol: '+',
      duration: 3,
    },
  ];

  return (
    <section id={id} className='about' style={{ height }} tabIndex={0}>
      <Row>
        <Col md={8} className='content'>
          <div className='content-text'>
            <div className='line-text'>
              <h4>About Us</h4>
            </div>
            <h1>We provide great services and ideas</h1>
            <p>
              {' '}
              IvP Web OÜ is a web development company founded by Ivana Pantazi,
              providing high-quality, cost-effective digital solutions to
              clients across Europe and beyond. Headquartered in Estonia, we
              work with organisations of all sizes, from start-ups and growing
              businesses to established enterprises, delivering tailored web and
              software solutions that support long-term growth.
            </p>
            <p>
              Our main focus is to help clients achieve their goals through
              modern, user-centred technology. We offer a wide range of
              services, including front-end and full-stack web development,
              responsive website design, accessibility and usability
              improvements, performance optimisation, mobile applications, and
              digital consultancy. Our experienced team works across projects of
              all sizes, from complex enterprise platforms to custom business
              websites and digital products.
            </p>

            <p>
              The guiding principle behind our work is to combine technical
              expertise, creative thinking, innovation, and reliable delivery to
              create effective solutions for our clients. We place strong
              emphasis on responsive design, accessibility, maintainability,
              performance, and user experience, ensuring that every product is
              built to modern standards. We are committed to delivering projects
              on time, within budget, and with a focus on long-term value.
            </p>
            <p>Don't hesitate to contact us for a quote.</p>
          </div>
        </Col>
        <Col md={4} className='skills'>
          <Container>
            <div className='line-text'>
              <h4>Facts</h4>
            </div>
            {facts.map(({ icon, value, text, symbol, duration }, index) => (
              <Col md={12} key={index}>
                <AnimationContainer delay={100} animation='fadeIn fast'>
                  <Counter
                    icon={icon}
                    value={value}
                    text={text}
                    symbol={symbol}
                    duration={duration}
                  />
                </AnimationContainer>
              </Col>
            ))}
          </Container>
        </Col>
      </Row>
    </section>
  );
};

export default About;
